export var variables = {
    fontText: '"Open Sans", sans-serif',
    colorDecorator: '#8B231D',
    colorWhite: '#fff',
    colorMainText: '#000',
    colorBorder: '#E9E9E9',
    colorFrame: '#2D3446',
    colorBackground: '#F1F3F6',
    colorGrey: '#788195',
    colorScrollbar: '#e8e8e8',
    darkestGrey: '#c5c5c5',
    colorInfo: '#1890ff',
};
